import React from 'react'
import './AuctionOfTheWeek.css'
import Timer from '../../../common/timer'
import FavouriteCheckbox from '../../atoms/FavoriteCheckbox'
import PrimaryButton from '../../atoms/PrimaryButton'
const AuctionOfTheWeek = ({ data, onClick }) => {
    if (!data) return null
    const isEnded = data.date_closed && new Date(data.date_closed) < new Date()

    const currentBid = data.wprice || data.sprice || 0
    const perUnit = data.qty > 1 ? `${data.qty} EUR / Unit` : ''

    return (
        <div className="auction-of-week-wrapper">
            <div className="auction-of-week">
                <div className="aow-corner top-left"></div>
                <div className="aow-corner top-right"></div>
                {/* <div className="aow-corner bottom-left"></div>
                <div className="aow-corner bottom-right"></div> */}

                <div className="aow-content">
                    <div className="aow-image">
                        <div onClick={(e) => e.stopPropagation()}>
                            <FavouriteCheckbox
                                watchlisted={data.watchlistid}
                                project_id={data.id}
                            />
                        </div>

                        <img
                            src={global.site_url + '/uploads/product/compressed/' + data.avatar}
                            alt={data.title}
                        />
                        <div className="aow-timer">
                            {!isEnded && 'ENDS IN '}
                            <Timer
                                date_added={data.date_added}
                                date_closed={data.date_closed}
                                withText={0}
                            />
                        </div>
                    </div>

                    <div className="aow-info">
                        <h3>{data.title || 'No title'}</h3>
                        <div className="d-flex justify-content-between current-bid-amount">
                            <div className="aow-bid text-center mb-3">
                                <strong>
                                    Current Bid: <span>{currentBid}&nbsp;EUR</span>
                                </strong>
                                {perUnit && <p>{perUnit}</p>}
                            </div>

                            <PrimaryButton label="Join Now" onClick={onClick} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AuctionOfTheWeek
